export type SeedResult = { ok: boolean; message: string; details?: string[] };

export const DEMO_SEED_KEY = 'toscana.demo.seed.v9';

export function hoy(): string {
  return new Date().toISOString().slice(0, 10);
}

export function horaDemo(hour: number, min = 0): string {
  const d = new Date();
  d.setHours(hour, min, 0, 0);
  return d.toISOString();
}

export async function tryStep(
  label: string,
  fn: () => Promise<string | void>,
  details: string[],
): Promise<boolean> {
  try {
    const msg = await fn();
    details.push(msg ? `${label}: ${msg}` : label);
    return true;
  } catch (e: unknown) {
    const m = e instanceof Error ? e.message : String(e);
    details.push(`${label} (omitido): ${m}`);
    return false;
  }
}

export function mergeResults(parts: SeedResult[]): SeedResult {
  const details = parts.flatMap(p => p.details ?? []);
  const ok = parts.every(p => p.ok);
  const messages = parts.map(p => p.message).filter(Boolean);
  return {
    ok,
    message: ok ? 'Datos demo sembrados.' : 'Sembrado parcial — revise detalles.',
    details: [...messages, ...details],
  };
}
